import { DividerColor } from "./types";

export const dividerColorMap: Record<DividerColor, string> = {
  transparent: "bg-transparent",
  current: "bg-current",
  white: "bg-white",
  black: "bg-black",
  brand: "bg-brand",
  "chartreuse-100": "bg-chartreuse-100",
  "light-grey": "bg-light-grey",
  "light-grey-75": "bg-light-grey-75",
  "cool-grey-40": "bg-cool-grey-40",
  "sand-200": "bg-sand-200",
  "grey-400": "bg-grey-400",
  "grey-500": "bg-grey-500",
  charcoal: "bg-charcoal",
  orange: "bg-orange",
  green: "bg-green",
  "green-dark": "bg-green-dark",
  "mid-green": "bg-mid-green",
  blue: "bg-blue",
  pink: "bg-pink",
  red: "bg-red",
  inherit: "bg-inherit",
  "light-blue": "bg-light-blue",
  "mid-blue": "bg-mid-blue",
  "outline-grey": "bg-outline-grey",
  "graphite-grey": "bg-graphite-grey",
  "green-light": "bg-green-light",
};
